module.exports = __webpack_public_path__ + "static/media/carousel3.1c29ad4e.jpg";